import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from 'kangarootime-ui';
import MultiItemSelect from '../../MultiItemSelect';
import { graphql } from 'react-apollo';
import { GET_CHANNEL_MESSAGEABLE_USERS } from '../../../graphql/queries';
import CreateChannelModal from '../CreateChannelModal';
import PrivateSwitch from './PrivateSwitch';

const NewChannelModal = ({
  isOpen,
  onClose,
  currentCenterId,
  existingChannels,
  employeeLegacyChatId,
  // gql props
  data: { getChannelMessageableUsers },
  ...props
}) => {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [filterValue, setFilterValue] = useState('');
  const [isPrivateChannel, setIsPrivateChannel] = useState(false);
  const [newChannelTitle, setNewChannelTitle] = useState('');
  const [newChannelTopic, setNewChannelTopic] = useState('');

  const hasTitle = newChannelTitle.trim().length > 3;
  const buttonDisabled = !hasTitle;

  const messageableUsers = getChannelMessageableUsers || [];
  const filteredUsers = messageableUsers.filter(u => u.name.toLowerCase().includes(filterValue));

  return (
    <CreateChannelModal
      isOpen={isOpen}
      onClose={onClose}
      title={isPrivateChannel ? 'Create a Private Channel' : 'Create a Channel'}
      subtitle="Channels are where your team members communicate. They're best when organized around a topic."
      buttonText='Create Channel'
      buttonDisabled={buttonDisabled}
      newChannelDetails={{
        name: newChannelTitle,
        topic: newChannelTopic,
        centerId: `${currentCenterId}`,
        private: isPrivateChannel,
        directMessage: false,
        invitedUserIds: selectedUsers.map(u => ({ id: `${u.id}`, type: 'employee' }))
      }}
      employeeLegacyChatId={employeeLegacyChatId}
    >
      <TextInput
        label='Name'
        helperText='Name must be at least 3 characters long'
        placeholder='ex: general'
        style={{ width: '100%', marginBottom: 8 }}
        value={newChannelTitle}
        onChange={event => setNewChannelTitle(event.target.value)}
      />
      <TextInput
        label='Purpose'
        helperText='The topic that this channel revolves around'
        placeholder=''
        style={{ width: '100%', marginBottom: 8 }}
        value={newChannelTopic}
        onChange={event => setNewChannelTopic(event.target.value)}
      />
      <MultiItemSelect
        label='Add people to this channel'
        items={messageableUsers}
        filteredItems={filteredUsers}
        onItemSelect={users => setSelectedUsers(users)}
        onFilter={filterValue => setFilterValue(filterValue)}
      />
      <PrivateSwitch
        isPrivate={isPrivateChannel}
        onChange={setIsPrivateChannel}
      />
    </CreateChannelModal>
  );
};

NewChannelModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  currentCenterId: PropTypes.string,
  existingChannels: PropTypes.array
};

export default graphql(GET_CHANNEL_MESSAGEABLE_USERS, {
  options: props => ({
    fetchPolicy: 'cache-and-network',
    variables: {
      centerId: props.currentCenterId
    }
  })
})(NewChannelModal);
